import React, {useState} from 'react'

function AboutCoreValues({data}) {
    const [isShown, setIsShown] = useState(0);
  return (

    <>
        
        <section className='about-core-values'>
            <div className='container'>
                <div className='top-head'>
                    <h2 className='ttl1'>Core values</h2>
                </div>
                <div className='value-list'>
                    {
                        data.map((response, index) =>{
                            return(
                                <div className={isShown === index ? "value-itm active" : "value-itm"}  onMouseEnter={()  => setIsShown(index)}
                                    onMouseLeave={() => setIsShown(0)} key={index}>
                                    <div className='cont-val'>
                                        <span className='img-cont'>
                                            <img src={response.Img1} className='img-st' alt={response.FeatHeading} width={40} height={40} />
                                            <img src={response.Img2} className='img-hvr' alt={response.FeatHeading} width={40} height={40} />
                                        </span>
                                        <h4>{response.heading}</h4>
                                    </div>
                                </div>
                            )
                        })
                    }  
                </div>
            </div>
        </section>

        
    </>
  )
}

export default AboutCoreValues